<template>
    <div class="error-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="error-content">
                        <img src="../../assets/img/error.png" alt="image">
                        <h3>Hata 404 : Sayfa Bulunamadı</h3>
                        <p>Aradığın sayfa silinmiş ya da yeri değiştirilmiş.</p>
                        <div class="btn-box">
                            <router-link to="/" class="default-btn">
                                <i class="flaticon-history"></i>
                                Geri Dön
                                <span></span>
                            </router-link>
                            <router-link to="/" class="default-btn">
                                <i class="flaticon-home"></i>
                                Ana Sayfa
                                <span></span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>